/**
 * Contexte de session du refacto rôles — DOUBLE MODE, miroir du back :
 *  - mode « portail » : le compte est migré aux briques ; il vit sous un portail
 *    actif et ses droits sont les briques effectives (portail ∩ compte) ;
 *  - mode « legacy » : rôle actif unique (admin, gestionnaires, comptes non migrés).
 * Les littéraux ci-dessous sont le contrat avec le back (Codes.Portails /
 * Codes.Briques) — comparaison ORDINALE (le back est sensible à la casse).
 */

export const PortailNames = {
  Distribution: 'Distribution',
  // Valeur wire back (Codes.Portails.Organisation) — le portail s'affiche
  // « Portail Plateforme » mais son NOM persisté/serveur reste « Organisation ».
  Plateforme: 'Organisation',
  // Zone des valideurs (et plus tard des gestionnaires) : les demandes qui leur
  // sont adressées. Portail minimal, sa seule brique est Valideur.
  Gestion: 'Gestion'
} as const;

export type PortailNameValue = (typeof PortailNames)[keyof typeof PortailNames];

export const BriqueNames = {
  Distribution: 'Distribution',
  Encaissement: 'Encaissement',
  SouscriptionCollective: 'Souscription collective',
  ConsultationPortefeuilleOrga: 'Consultation portefeuille orga',
  ConceptionOffre: "Conception d'offre",
  GestionLeads: 'Gestion leads',
  ConsultationPorteurRisque: 'Consultation porteur de risque',
  // Créer les contrats collectifs de portée plateforme (Scope=Plateforme) —
  // une brique d'ACTION du Portail Plateforme, pas de consultation.
  SouscriptionPlateforme: 'Souscription plateforme',
  // Brique du Portail Gestion : valider les devis des tunnels qui nomment le
  // compte valideur.
  Valideur: 'Valideur'
} as const;

export type BriqueNameValue = (typeof BriqueNames)[keyof typeof BriqueNames];

export interface RoleSession {
  mode: 'legacy' | 'portail';
  /** Mode legacy : nom du rôle actif. */
  roleName?: string | null;
  /** Mode portail : nom du portail actif. */
  portail?: string | null;
  /** Mode portail : briques effectives (portail actif ∩ briques du compte). */
  briques: readonly string[];
}

export const LEGACY_EMPTY_SESSION: RoleSession = {
  mode: 'legacy',
  roleName: null,
  briques: []
};

export const sessionHasBrique = (
  session: RoleSession,
  brique: string
): boolean => session.briques.includes(brique);

/** Libellés du sélecteur de portails. */
export const portailLabel = (portail: string): string =>
  portail === PortailNames.Plateforme
    ? 'Portail Plateforme'
    : portail === PortailNames.Distribution
      ? 'Portail Distribution'
      // Tout portail se présente préfixé — un nom nu (« Distribution ») se
      // confondrait avec le rôle-brique du même nom.
      // Portail Gestion : le repli produit déjà « Portail Gestion ».
      : `Portail ${portail}`;
